import React from 'react'

const DashboardHeader = ({ userData }) => {
  return (
    <div className="dashboard-header">
      <div className="overview-section">
        <h1 className="overview-title">Overview</h1>
        <p className="overview-subtitle">In this section you will have a glimpse of your overall reports.</p>
      </div>
      <div className="user-profile-section">
        <div className="user-info">
          <div className="user-details">
            <h3 className="user-name">{userData?.firstName} {userData?.lastName}</h3>
            <span className="manage-profile">Manage Profile</span>
          </div>
          <div className="user-avatar-placeholder">
            {userData?.firstName?.[0]}{userData?.lastName?.[0]}
          </div>
        </div>
      </div>

      <style jsx>{`
        .dashboard-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 30px;
        }

        .overview-title {
          font-size: 28px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 8px 0;
        }

        .overview-subtitle {
          color: #666;
          font-size: 14px;
          margin: 0;
        }

        .user-profile-section {
          display: flex;
          align-items: center;
        }

        .user-info {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .user-details {
          text-align: right;
        }

        .user-name {
          font-size: 16px;
          font-weight: 600;
          color: #1a1a1a;
          margin: 0;
        }

        .manage-profile {
          font-size: 12px;
          color: #666;
        }

        .user-avatar-placeholder {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #4A90E2;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-size: 14px;
        }

        @media (max-width: 768px) {
          .dashboard-header {
            flex-direction: column;
            gap: 16px;
          }
        }
      `}</style>
    </div>
  )
}

export default DashboardHeader 